// extracted by mini-css-extract-plugin
module.exports = {"pills":"NavPills_pills__2MvkK","pill":"NavPills_pill__1np5o","link":"NavPills_link__3gTXs","active":"NavPills_active__YfW7p","disabled":"NavPills_disabled__1OWd8"};